import * as React from "react";
import { ContentPicker } from "../components/ContentPicker";
import { ContentViewModel, EntityTypes, ImageTypes, ListContent } from "../content/ContentStore";

const GameSplashPicker = ({ onSelect, disabled, uri }) => {
    const [options, setOptions] = React.useState([] as ContentViewModel[]);

    React.useEffect(() => {
        ListContent(ImageTypes.Splash, EntityTypes.Game, 0, 50).then((res) => {
            setOptions(res.result);
        });
    }, []);
    return <ContentPicker label="Splash" onSelect={onSelect} uri={uri} width="300px" options={options} optionWidth="256px" optionHeight="" optionsPageSize={3} suggestedSize="1280px x 850px" disabled={disabled}></ContentPicker>;
};

export default GameSplashPicker;
